export default __webpack_public_path__ + "static/31-00f5fa3e1821ae4cc9926e5d28844aff.jpg";